<template>
    <button type="button" class="btn" 
        :class="( link ? 'btn-link' : 'btn-outline-secondary' ) + ' ' + ( sizing == 'sm' ? 'btn-sm' : '' ) + ' ' + classes" v-if="model && id" @click="abrir ()">
        Log
    </button>
</template>

<script>
export default {
    props: ['model', 'id', 'sizing', 'link', 'campos', 'classes'],

    methods: { 
        abrir () { 
            this.$util.logAudit(this.model, this.id, { campos: this.campos });
        }
    }
}
</script>